export const DEPLOYMENT_TYPES = ["deploy", "redeploy"];
